<header>
    <app-nav-top></app-nav-top>
</header>
<main>
    <div id="loadingSpinnerContainer" class="loading-spinner-container" *ngIf="loading">
        <div>
            <img src="../../../assets/loading.gif" class="loading-spinner">
        </div>
    </div>
    <router-outlet></router-outlet>
</main>